module.exports = __webpack_public_path__ + "static/media/premium.a06e144a.png";